"use strict";

exports.__esModule = true;
exports.CloseButtonUI = exports.IconUI = exports.config = void 0;

var _styled = _interopRequireDefault(require("../styled"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _baseStylesCss = _interopRequireDefault(require("../../styles/resets/baseStyles.css.js"));

var _color = require("../../styles/utilities/color");

var _forEach = _interopRequireDefault(require("../../styles/utilities/forEach.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var config = {
  color: (0, _color.getColor)('grey.700'),
  colorHover: (0, _color.getColor)('grey.800'),
  colorActive: (0, _color.getColor)('charcoal.200'),
  padding: '2px 6px',
  size: '32px',
  sizes: {
    md: {
      size: '32px',
      padding: '2px 6px'
    },
    sm: {
      size: '28px',
      padding: '2px 3px'
    },
    xs: {
      size: '24px',
      padding: '2px 1px'
    },
    tiny: {
      size: '20px',
      padding: '0 0'
    }
  }
};
exports.config = config;
var IconUI =
/*#__PURE__*/
(0, _styled.default)(_Icon.default, {
  target: "ez3aqz60"
})("opacity:0.5;position:relative;transition:opacity 0.1s ease;z-index:1;");
exports.IconUI = IconUI;
var CloseButtonUI =
/*#__PURE__*/
(0, _styled.default)('button', {
  target: "ez3aqz61"
})(_baseStylesCss.default, ";appearance:none;cursor:pointer;outline:none;position:relative;background-color:white;border:none;border-radius:50%;color:", config.color, ";cursor:pointer;display:block;height:", config.size, ";padding:", config.padding, ";position:relative;transition:background-color 300ms ease;width:", config.size, ";&:hover,&:focus{color:", config.colorHover, ";outline:none;", IconUI, "{opacity:0.8;}}&:active{color:", config.colorActive, ";outline:none;", IconUI, "{opacity:0.8;}}&.is-seamless{background-color:transparent;color:currentColor;&:hover,&:active,&:focus{background-color:transparent;color:currentColor;}}", makeSizeStyles, ";");
exports.CloseButtonUI = CloseButtonUI;

function makeSizeStyles() {
  return (0, _forEach.default)(config.sizes, function (size, values) {
    return "\n    &.is-" + size + " {\n      height: " + values.size + ";\n      padding: " + values.padding + ";\n      width: " + values.size + ";\n    }\n  ";
  });
}